import API from 'common/api';

import { RESET_VALUES } from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) => {
    API.cancelAll();
    dispatch(actions[RESET_VALUES]());
};
